export default __webpack_public_path__ + "static/media/12.68d6fc6e.svg";